module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2am"
  }, [_c('a', {
    attrs: {
      "id": "note"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("A NOTE ABOUT THE YOUNG READERS EDITION BY CATHERINE RYAN HYDE")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("T")]), _vm._v("he book you are holding in your hands has become historical fiction. It’s set in the 1990s, when Clinton was first running for president. When newspapers were still the dominant media outlet, and no one had a cell phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I imagine that will be an interesting experience for readers of this edition, most of whom had not yet been born.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But it wasn’t historical fiction when I wrote it. When I drafted the original edition of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Pay It Forward,")]), _vm._v(" it "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("was")]), _vm._v(" the 1990s. In fact, the idea for the book was first planted in my head nearly twenty years before that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here’s how it all began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was 1978. I was driving my car, an aging, poorly maintained Datsun (translation for younger people: Nissan) in a bad neighborhood late at night.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("I was alone.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It was my own fault that my car was in such miserable condition. I was young in 1978. And I had this theory when I was young. I thought it was cheaper to just drive your car and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("not")]), _vm._v(" take it to the mechanic. People laugh when I say that, but it made perfect sense to me at the time. Mechanics cost money, right? Therefore, if you don’t go to them, you save money. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Right?")]), _vm._v(" It’s thinking reserved for the new driver, and it’s one of those theories that works fairly well until the day it doesn’t anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was that day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached the stop sign at the end of the freeway ramp. I put my foot on the brake, and the engine stalled. That might sound unusual to you, but the engine always stalled when I took my foot off the gas. It’s what happens when you never take your car to the mechanic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached for the ignition to start it up again, and all the electricity in my car suddenly died. Headlights, dash lights . . . out. Now I was in a bad neighborhood late at night "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("in the dark")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I noticed a curl of smoke.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("Whether or not you’ve experienced this yourself (and I hope you never have to), you probably know that when you’re in a bad neighborhood late at ")]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("night, you feel a powerful incentive to stay in your car with the doors locked. Until the car fills up with smoke. This might very well be the textbook definition of being “between a rock and a hard place.”")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I jumped out. Into the bad neighborhood. Alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or so I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked up to see two men, two total strangers, running in my direction. Very fast. One of them was carrying a blanket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many thoughts danced in my head. I think the first was, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I never made out a will")]), _vm._v(". Then I realized it didn’t matter, because I had nothing to leave to anybody anyway. Except the car. Which was on fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Probably other thoughts danced around in there as well. I can tell you one thought I’m sure did not dance: rescue. The crazy idea that these men might be coming to my rescue was, unfortunately, nowhere on the list.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the men pushed past me and popped the hood of my car from the inside. The other, the man with the blanket, opened the hood, leaned his entire upper body into my flaming engine compartment, and put the fire out using only the blanket and his bare hands.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("I just want to pause here, briefly, for emphasis. ")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("His")]), _vm._v(" bare hands. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("My")]), _vm._v(" flaming engine compartment. Isn’t that a fascinating combination between total strangers? I thought so too.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Right around the time they got the fire out, the fire department showed up. And I have no idea who called them. When speaking to groups of young students, as I often have, they like to guess that someone had a cell phone and I didn’t notice. No. Not in 1978. No one had a cell phone. This was back when we had emergency call boxes on the highway. (I guess we still do, but we ignore them, because we all have cell phones.) Apparently, someone going by on the freeway behind us had seen the trouble I was in and stopped to call the fire department.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, I certainly would call the fire department for a stranger. I hope most of us would. For anyone. But would I lean my upper body into someone’s flaming engine compartment and put out the fire with my bare hands?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s a big question.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("By the time the firefighters arrived, there wasn’t much left for them to do. The fire was already out. So they just helped us push my car over to the side of the road. They showed me how the fire started. (Not interesting.) And they explained what would ")]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("have happened if it hadn’t been put out. (Not happy, but interesting.)")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("You see, the fire was burning along the throttle line. And would soon have made its way back to the gas tank.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s when I realized: These two men may have saved more than just my car. They may have saved my life. And they may have put their own lives at risk to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned around to thank them, and discovered that they had already packed up and driven away. In the confusion of talking to the fire department, they’d left. And I hadn’t noticed. This had been the biggest favor I’d ever received, and from total strangers. And I hadn’t even said thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So what do you do with a favor that big if you can’t pay it back? I think you know. If you don’t, just keep reading beyond this introduction.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("I’ve had many people ask me, in response to that story, “So, you’re saying that if those two men hadn’t stopped that night, the whole ‘pay it forward’ thing never would have happened?” And I say, “I’ll take it a step further than that. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("If they hadn’t left without saying good-bye")]), _vm._v(", there never would have been a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Pay it Forward")]), _vm._v(" novel.” And if there hadn’t been the novel, there wouldn’t have ")]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("been two dozen language translations of it around the world, the movie, the foundation, the real-life global movement. If those two strangers had stayed around to absorb my gratitude, I might simply have gotten their names and sent them a holiday card every year for the rest of our natural lives. And that might have felt like enough.")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But they left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Amazingly, I was able to get the car fixed. And then I went back to driving the freeways for my business. But something had changed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly, I had one eye on the side of the road, looking for someone broken down or otherwise in trouble. And I knew that when I saw such a person, I would stop. And of course I did stop. Even though I never had before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That act of kindness changed me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And because it did, I began watching to see if other acts of kindness changed other people. And, almost invariably, I saw that they did. I observed small acts of kindness changing people in small ways. And I felt I’d already proved that a big enough act of kindness can alter the course of a person’s life entirely. But, big or small, I’ve still yet to see acts of kindness fail.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b4f9b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/note.vue
// module id = 60
// module chunks = 0